<template>
  <div class="inventory-pick">
    <template v-if="!store.error && !store.loading && store.data">
      <picklist-detail
        :data="store.data"
        can-add
        can-delete
        v-model="picklistPicker.selectedPosition"
      />
    </template>
    <template v-if="store.error">
      <error :module="store.$id" />
    </template>
    <template v-if="store.loading">
      <loading />
    </template>
  </div>
</template>

<script setup lang="ts">
import Loading from '@/components/Loading.vue';
import ErrorComp from '@/components/Error.vue';
import PicklistDetail from '@/components/Picklist/PicklistDetail.vue';
import pinia from '@/plugins/pinia';
import {doConfirm} from '@/util';
import {ApiPicklistState} from '@/model/Picklist';
import {onBeforeRouteLeave} from 'vue-router';
import {useApplicationState} from '@/store/applicationState';
import useDetailPicklistStore from '@/store/detailPicklist';
import {usePicklistPickerStore} from '@/store/picklistPickerV2';
import {useStorageRaw} from '@/composables/storage';

const applicationState = useApplicationState(pinia);
const picklistPicker = usePicklistPickerStore(pinia);
const store = useDetailPicklistStore();
applicationState.updateTitle(store.data?.Picklistnr ? `Bestellvorschlag ${store.data?.Picklistnr}` : 'Neuer Bestellvorschlag');
useStorageRaw(
    store,
    (picklist) => picklist?.Picklistnr > 0 ? `Bestellvorschlag ${picklist?.Picklistnr}` : 'Neuer Bestellvorschlag',
    null,
    () => {
      picklistPicker.edit().catch(console.error);
    },
);

onBeforeRouteLeave(async (_to, _from, next) => {
  if (picklistPicker.picklist?.Status === ApiPicklistState.Active) {
    if (await doConfirm('Soll die Anlage des Bestellvorschlags wirklich abgebrochen werden?', 'Wirklich abbrechen?')) {
      await picklistPicker.cancel();
    } else {
      next(false);
      return;
    }
  }
  next();
});


defineExpose({
  Loading,
  Error: ErrorComp,
  PicklistDetail,
  picklistPicker,
  store,
});
</script>
